import { Award, Clock, PoundSterling, ShieldCheck, ThumbsUp, Users } from "lucide-react";

const features = [
  {
    icon: ShieldCheck,
    title: "Fully Licensed & Insured",
    description: "Fully qualified and insured electrician. Every job carried out safely and to code.",
  },
  {
    icon: PoundSterling,
    title: "Upfront, Transparent Pricing",
    description: "No hidden costs. We agree the price with you before any work begins.",
  },
  {
    icon: Clock,
    title: "24/7 Emergency Response",
    description: "Electrical emergencies don't wait for office hours, and neither does Andrew.",
  },
  {
    icon: Users,
    title: "Family-Trained Expertise",
    description: "Trained by his grandad and dad, Andrew brings generations of electrical knowledge to every job.",
  },
  {
    icon: Award,
    title: "Tidy, Quality Workmanship",
    description: "Andrew and the team always clean up after themselves and take pride in a neat, professional finish.",
  },
  {
    icon: ThumbsUp,
    title: "80+ Five-Star Reviews",
    description: "Trusted by homeowners and businesses across the Fylde Coast, all rated 5 stars on Google.",
  },
];

const stats = [
  { value: "80+", label: "5-Star Reviews" },
  { value: "4.9★", label: "Google Rating" },
  { value: "24/7", label: "Emergency Cover" },
  { value: "100%", label: "Satisfaction Guaranteed" },
];

export const WhyUs = () => {
  return (
    <section id="why-us" className="scroll-mt-20 bg-secondary/30 py-20">
      <div className="mx-auto max-w-360 px-4 md:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="text-sm font-semibold tracking-wider text-primary uppercase">
              Why Choose Us
            </span>
            <h2 className="mt-2 text-3xl font-bold sm:text-4xl">
              The Fylde Coast Sparky You Can Count On
            </h2>
            <p className="mt-4 text-muted-foreground">
              E.I.M Electrical Contractors is proud to serve homes and
              businesses across Blackpool, Lytham St Annes, Cleveleys,
              Fleetwood, Poulton-le-Fylde and Preston. Here's what sets Andrew and E.I.M apart.
            </p>
            <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2">
              {features.map((feature) => (
                <div key={feature.title} className="flex gap-3">
                  <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-primary/10">
                    <feature.icon className="size-5 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold">{feature.title}</h3>
                    <p className="mt-1 text-sm text-muted-foreground">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 sm:gap-6">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-2xl border border-white/10 bg-card p-8 text-center shadow-sm"
              >
                <div className="text-4xl font-bold text-primary">{stat.value}</div>
                <div className="mt-2 text-sm text-muted-foreground">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
